import { render, staticRenderFns } from "./CtaNavMobile.vue?vue&type=template&id=96b10840&scoped=true&"
import script from "./CtaNavMobile.vue?vue&type=script&lang=js&"
export * from "./CtaNavMobile.vue?vue&type=script&lang=js&"
import style0 from "./CtaNavMobile.vue?vue&type=style&index=0&id=96b10840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b10840",
  null
  
)

export default component.exports